export default __webpack_public_path__ + "static/media/menu.ee8c6ed3.jpg";